export default __webpack_public_path__ + "static/53-214bde001c9d380567ee4d589b439005.png";